import styled from 'styled-components';

const SlackChannelRow = styled.div`
  align-items: center;
  display: flex;
  gap: 12px;
  margin-top: 8px;

  > *:first-child {
    flex: 1;
  }
`;

export default SlackChannelRow;
